import ComponentOutlet from '../storyblok/ComponentOutlet';

export default function ColumnCmp({ body, ...props }) {
	return (
		<div {...props}>
			<ComponentOutlet components={body} />
		</div>
	);
}
